import { Link } from 'react-router-dom'

const servicos = [
  {
    to: '/imprimir-boleto',
    icon: 'fa-file-invoice-dollar',
    titulo: 'Imprimir Boleto',
    desc: 'Consulte e imprima seus boletos informando seu CNPJ e código de cliente.',
    cor: 'bg-blue-50 group-hover:bg-quantum-blue',
    iconCor: 'text-quantum-blue group-hover:text-white',
  },
  {
    to: '/senha-mensal',
    icon: 'fa-key',
    titulo: 'Senha Mensal',
    desc: 'Consulte a senha mensal de acesso ao sistema com seu CNPJ.',
    cor: 'bg-green-50 group-hover:bg-green-600',
    iconCor: 'text-green-600 group-hover:text-white',
  },
  {
    to: '/baixar-suporte',
    icon: 'fa-download',
    titulo: 'Baixar Suporte',
    desc: 'Baixe as ferramentas de acesso remoto para atendimento técnico.',
    cor: 'bg-orange-50 group-hover:bg-orange-500',
    iconCor: 'text-orange-500 group-hover:text-white',
  },
  {
    to: '/acesso-contador',
    icon: 'fa-calculator',
    titulo: 'Acesso Contador',
    desc: 'Área exclusiva para contadores acessarem relatórios e documentos fiscais.',
    cor: 'bg-purple-50 group-hover:bg-purple-600',
    iconCor: 'text-purple-600 group-hover:text-white',
  },
]

export default function CentralDoUsuario() {
  return (
    <>
      {/* Hero */}
      <section
        className="relative bg-quantum-blue py-20 text-white bg-cover bg-center"
        style={{ backgroundImage: "url('/img/contabilidade.jpg')" }}
      >
        <div className="absolute inset-0 bg-quantum-blue/80" />
        <div className="relative max-w-7xl mx-auto px-4 text-center">
          <i className="fa-solid fa-user-shield text-5xl text-quantum-red mb-4 block" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Central do Usuário</h1>
          <p className="text-blue-200 text-lg max-w-xl mx-auto">
            Acesse os serviços disponíveis para clientes Quantum. Escolha o que você precisa abaixo.
          </p>
        </div>
      </section>

      {/* Cards de serviços */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {servicos.map(({ to, icon, titulo, desc, cor, iconCor }) => (
              <Link
                key={to}
                to={to}
                className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-transparent hover:border-gray-200"
              >
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center mb-5 transition-colors ${cor}`}>
                  <i className={`fa-solid ${icon} text-2xl transition-colors ${iconCor}`} />
                </div>
                <h2 className="text-xl font-bold text-quantum-blue mb-3">{titulo}</h2>
                <p className="text-gray-500 leading-relaxed">{desc}</p>
                <div className="mt-4 flex items-center gap-2 text-quantum-red text-sm font-semibold">
                  Acessar <i className="fa-solid fa-arrow-right text-xs" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Suporte rápido */}
      <section className="py-12 bg-white border-t border-gray-100">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <p className="text-gray-500 mb-4">Precisa de ajuda? Nossa equipe está disponível:</p>
          <div className="flex flex-wrap justify-center gap-6">
            <a href="tel:+556332143357" className="flex items-center gap-2 text-quantum-blue font-semibold hover:text-quantum-red transition-colors">
              <i className="fa-solid fa-phone" /> (63) 3214-3357
            </a>
            <a href="https://wa.me/5563984042819" target="_blank" rel="noreferrer"
              className="flex items-center gap-2 text-green-600 font-semibold hover:text-green-700 transition-colors">
              <i className="fa-brands fa-whatsapp" /> WhatsApp
            </a>
            <a href="mailto:contato@sistemaquantum.com.br"
              className="flex items-center gap-2 text-quantum-blue font-semibold hover:text-quantum-red transition-colors">
              <i className="fa-solid fa-envelope" /> E-mail
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
